/**
 * Analytics module
 * Loads Google Analytics (gtag.js) from the bundle so the CSP can stay at script-src 'self'
 * plus the Google hosts, without needing inline scripts.
 */

export const GA_MEASUREMENT_ID = 'G-44RVK04J99';

/**
 * Injects gtag.js and configures the measurement ID. Safe to call more than once.
 * @param {Document} doc - The document object
 * @param {Window} win - The window object
 * @param {string} id - GA4 measurement ID
 * @returns {boolean} True if gtag was initialized, false if it was already loaded
 */
export function initAnalytics(doc = document, win = window, id = GA_MEASUREMENT_ID) {
  if (win.__gaInitialized) return false;
  win.__gaInitialized = true;

  win.dataLayer = win.dataLayer || [];
  win.gtag = function gtag() {
    win.dataLayer.push(arguments);
  };
  win.gtag('js', new Date());
  win.gtag('config', id);

  const script = doc.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  doc.head.appendChild(script);
  return true;
}
